import React, { useCallback } from 'react';

import { TypeFilters } from '~/components';
import { t } from '~/helpers';

export default function Demo() {
  const handleSubmit = useCallback((value) => {
    console.log('handleSubmit', value);
  }, []);

  return (
    <TypeFilters
      numberOfYears={9}
      options={[{ label: t('s.geral.filtro.periododatahora'), value: 1 }]}
      onCallback={handleSubmit}
      initialURL="/turno/getturnosinicio"
      finalURL="/turno/getturnosfim"
      code="ELE"
    />
  );
}
